const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment-timezone');
/**
 * Defines the media viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the global Analyze functions and properties
 * @argument {Files} Files the resource defined to manage Files
 * @argument {Assignments} Assignments the resource defined to manage Assignments
 */
app.directive('workshopViewer', ['Application', 'Authorization', 'Workshops', 'WorkshopInstances', 'UserWorkshops', 'ContentAuth', 'SurveyHelper', 'Analyze', 'Categories', '$q', '$location', '$translate', function (Application, Authorization, Workshops, WorkshopInstances, UserWorkshops, ContentAuth, SurveyHelper, Analyze, Categories, $q, $location, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      contentId: '=',
      checkFull: '@',
      fullData: '=?',
      instances: '=?',
      specialClose: '&?',
      preview: '=?',
      journeyId: '=?'
    },
    template: require('../../templates/directives/workshop-viewer.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;
      self.tempshowcalendar = window.tempshowcalendar;
      self.user = Authorization.getAuthToken().user;
      self.currentUrl = Application.navigation.getUrl();
      self.allowedRoles = ['admin', 'creator'];
      self.inEditing = new RegExp('edit').test(self.currentUrl);
      self.routeParameters = Application.navigation.getRouteParameters();
      self.isAdmin = self.allowedRoles.indexOf(self.user.role) !== -1;
      self.workshop = {};
      self.activeInstance = {};
      self.translations = {};
      self.inJourney = !!$scope.journeyId;
      var guessedTz = moment.tz.guess();
      if (!self.inEditing) {
        self.tracking = new Application.Tracking(Analyze, moment, 'workshop', null);
      }

      self.recordingsModal = false;
      self.hideSurvey = true;
      self.expandSurvey = false;
      
      self.languageAsVirtual = false;
      if(Application.LAYOUT === 'lyft'){
          self.languageAsVirtual = true ;
      };

      self.flags = Application.features.flags();

      self.recordSurveyView = () => {
        Analyze.record({resource: 'views'}, {content: self.workshop.surveys[0].survey_id, content_type: 'survey'});
      };
      
      self.recordingOpts = {
        recordings: [],
        show: false,
        selected: 0,
        select: function(index) {
          if (self.recordingOpts.recordings[index] && self.recordingOpts.recordings[index].link) {
            self.recordingOpts.selected = index;
          }
        },
        parseRecordings: function(options) {
          self.recordingOpts.recordings = options.map(function(item) {
            item.recording_type = item.recording_type ? item.recording_type.replace(/_/g, " ").replace(/shared/g, "").replace(/screen/g, "").replace(/with/g, "") : '';
            return item;
          });

        }
      };

      self.info = {
        isWaiting: false,
        isRegistered: false,
        // calendarModal: false,
        showJoin: false,
        userLocations: [],
        contentId: $scope.contentId || self.routeParameters.id,
        contentType: 'workshop',
        activeTab: 'information',
        retakeWorkshopsUnlimited: false,
        retakeWorkshopsAttendanceRequired: false,
        activeId: '',
        gCalLink: '',
        iCalDl: '',
        image: function () {
          if (self.workshop.banner_image || self.workshop.image) {
            var imageUrl = self.workshop.banner_image ? self.workshop.banner_image : self.workshop.image;
            return Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + '/' + imageUrl;
          }
          return '';
        },
        goDiscussion: function() {
          self.info.activeTab = 'discussion';
        },
        getUserParticipation: function() {
          return UserWorkshops.find({
            workshop: self.info.contentId,
            user: self.user._id,
            fields: 'company,user,workshop,workshop_instance,active_status,status_history'
          }).$promise;
        },
        getUserLocations: function() {
          var deferred = $q.defer();

          if (!self.user.linked_locations || !self.user.linked_locations.length || !self.user.linked_locations[0]) {
            deferred.resolve([]);
          }
          Categories.get({subresource: self.user.linked_locations[0], fields:'name,parent', 'parent-populate': 'name,parent'}).$promise
          .then(function(location) {
            var options = [];
            if (location && location._id) {
              options.push(location._id);
            }

            if (location.parent) {
              if (location.parent._id) {
                options.push(location.parent._id);
              }
              if (location.parent.parent) {
                options.push(location.parent.parent);
              }
            }
            deferred.resolve(options);
          }).catch(function(error) {
            deferred.resolve([]);
          });

          return deferred.promise;
        },
        setUserParticipation: function(items) {
          self.info.isRegistered = false;
          self.info.isWaiting = false;
          self.info.registeredInstance = '';
          var dropIn;
          items.forEach(function(item) {
            if (!item) {
              return;
            }
            if (item.active_status === 'registered') {
              dropIn = item;
              self.info.isRegistered = true;
              self.info.registeredInstance = item.workshop_instance;
              self.info.registrationId = item._id;
            }
            if (item.active_status === 'waiting') {
              dropIn = item;
              self.info.isWaiting = true;
            }
          });
          return dropIn;
        }
      };

      self.instances = {
        loading: false,
        options: [],
        optionDirectory: {},
        optionNames: [],
        choosing: false,
        multiDate: false,
        setActive: function(type, initial) {
          if (!this.options || !this.options.length) {
            return;
          }
          var instance;
          if (initial) {
            instance = this.options[0];
          }
          if (this.optionDirectory[type]) {
            instance = this.optionDirectory[type];
          }
          if (initial && self.routeParameters.date && this.optionDirectory[self.routeParameters.date]) {
            instance = this.optionDirectory[self.routeParameters.date];
          }
          if (!instance) {
            return;
          }
          self.activeInstance = Object.assign({
            availableSeats: 0,
            availableWait: 0,
            userActive: null,
            status: 'loading'
          }, instance);
          self.info.activeId = self.activeInstance._id;
          this.multiDate = false;
          var start = moment(new Date(instance.start_date).valueOf());
          var end = moment(new Date(instance.end_date).valueOf());
          if (end.diff(start, 'days') > 0) {
            this.multiDate = true;
          }
          this.makeIcs(self.activeInstance);
          this.getSeats();
          this.setInstanceNames(initial && !type);
          this.choosing = false;
          if (!$scope.fullData && !self.inJourney) {
            $location.search('date', (self.activeInstance._id));
          }
        },
        setInstanceNames: function(reSelect) {
          if (!this.options || !this.options.length) {
            return;
          }
          self.instances.optionNames = [];
          var siteMatches = [];
          var standardDates= [];
          var selection = [];
          this.options.forEach(function(item) {
            if (!item._id || !item.start_date) {
              return;
            }
            var site = item.site || '';
            var name;
            if (item.online) {
              name = 'Online';
            }
            if (!name && item.location) {
              name = item.location.venue || item.location.city_state || item.location.country || item.location.address_1 || item.location.address_2 || 'In Person';
            }
            name = name || 'In Person';
            var startMoment = moment(new Date(item.start_date).valueOf()).tz(guessedTz);
            name = startMoment.format('MMM D, YYYY') + ' \@ ' + startMoment.format('LT') + ' | ' + name ;
            var siteMatch = site && self.info.userLocations.indexOf(site) !== -1;
            self.instances.optionDirectory[item._id] = item;
            if (self.activeInstance && self.activeInstance._id === item._id) {
              selection.push({name: name, value: item._id, start: new Date(item.start_date).valueOf(), siteMatch: true});
              return;
            }
            if (siteMatch) {
              siteMatches.push({name: name, value: item._id, start: new Date(item.start_date).valueOf(), siteMatch: true});
              return;
            }
            standardDates.push({name: name, value: item._id, start: new Date(item.start_date).valueOf(), siteMatch: false});
          });
          siteMatches.sort(function (a, b) {
            return a.start - b.start;
          });
          standardDates.sort(function (a, b) {
            return a.start - b.start;
          });
          self.instances.optionNames = selection.concat(siteMatches, standardDates);
          if (self.languageAsVirtual) {
            for(var i = 0; i < self.instances.optionNames.length; i++){
              var oldVal = self.instances.optionNames[i].name;
              self.instances.optionNames[i].name = oldVal.replace(/Online/g, 'Virtual');
            };
          };
          if (reSelect && self.instances.optionNames[0] && self.instances.optionNames[0].site_match) {
            self.instances.setActive(self.instances.optionNames[0].value);
          }
        },
        changeDate: null,
        getSeats: function() {
          UserWorkshops.find({
            workshop: self.info.contentId,
            workshop_instance: self.activeInstance._id,
            fields: 'company,user,workshop,workshop_instance,active_status,status_history'
          }).$promise.then(function(userWorkshops) {
            var availableSeats = self.activeInstance.seats;
            var availableWait = self.activeInstance.waitlist_seats;
            if (userWorkshops && userWorkshops.length) {
              for (var i = 0; i < userWorkshops.length; i++) {
                if (!userWorkshops[i]) {
                  continue;
                }
                if (userWorkshops[i].user && userWorkshops[i].user.toString() === self.user._id.toString()) {
                  self.activeInstance.userActive = userWorkshops[i];
                }
                if (userWorkshops[i].active_status && userWorkshops[i].active_status === 'registered') {
                  availableSeats--;
                  continue;
                }
                if (userWorkshops[i].active_status && userWorkshops[i].active_status === 'waiting') {
                  availableWait--;
                }
              }
            }

            self.activeInstance.availableSeats = availableSeats >= 0 ? availableSeats : 0;
            self.activeInstance.availableWait = availableWait >= 0 ? availableWait : 0;

            if (!self.activeInstance.allow_waitlist) {
              self.activeInstance.availableWait = 0;
            }

            self.instances.setButtons();
          }).catch(function(error) {

          });
        },
        setButtons: function(userWorkshops) {
          self.activeInstance.canLeave = false;
          self.activeInstance.canLeaveWait = false;
          self.activeInstance.attended = false;
          self.activeInstance.canJoin = false;
          self.activeInstance.canWait = false;
          self.activeInstance.noOptions = false;

          if (self.activeInstance.userActive) {
            if (self.activeInstance.userActive.active_status === 'attended') {
              self.activeInstance.attended = true;
              return;
            }
          }
          if (self.activeInstance.userActive) {
            if (self.activeInstance.userActive.active_status === 'registered') {
              self.activeInstance.canLeave = true;
              return;
            }
            if (self.activeInstance.userActive.active_status === 'waiting') {
              self.activeInstance.canLeaveWait = true;
              return;
            }
          }
          if (self.activeInstance.availableSeats) {
            self.activeInstance.canJoin = true;
            return;
          }
          if (self.activeInstance.availableWait) {
            self.activeInstance.canWait = true;
            return;
          }
          self.activeInstance.noOptions = true;
        },
        dateFormat: function(location, type) {
          if (!self.activeInstance.start_date) {
            return '';
          }
          if (location === 'top') {
            if (type === 'month') {
              return moment(new Date(self.activeInstance.start_date).valueOf()).tz(guessedTz).format('MMM');
            }
            if (type === 'day') {
              return moment(new Date(self.activeInstance.start_date).valueOf()).tz(guessedTz).format('D');
            }
          }
          if (location === 'mid-full') {
            if (type === 'date') {
              return moment(new Date(self.activeInstance.start_date).valueOf()).tz(guessedTz).format('MMM D, YYYY');
            }
            if (type === 'time') {
              if (!self.instances.multiDate) {
                return moment(new Date(self.activeInstance.start_date).valueOf()).tz(guessedTz).format('h:mma') + ' - ' + moment(new Date(self.activeInstance.end_date).valueOf()).tz(guessedTz).format('h:mma z');
              }
              return moment(new Date(self.activeInstance.start_date).valueOf()).tz(guessedTz).format('h:mma z') + ' to';
            }
          }
          if (location === 'mid-full-end') {
            if (type === 'date') {
              return moment(new Date(self.activeInstance.end_date).valueOf()).tz(guessedTz).format('MMM D, YYYY');
            }
            if (type === 'time') {
              return moment(new Date(self.activeInstance.end_date).valueOf()).tz(guessedTz).format('h:mma z');
            }
          }
        },
        checkJoin: function() {
          if (self.inPreview) {
            Application.messaging.addMessage({type: 'info', duration: 4, text: self.translations['workshopviewer.action_disabled']});
            return;
          }
          if (self.info.retakeWorkshopsUnlimited) {
            self.instances.join();
            return;
          }
          if (self.attended && self.info.retakeWorkshopsAttendanceRequired && !self.info.isRegistered && !self.info.isWaiting) {
            self.instances.join();
            return;
          }
          if (self.info.isRegistered) {
            self.info.showJoin = true;
            return;
          }
          if (self.info.isWaiting) {
            self.info.showJoin = true;
            return;
          }
          self.instances.join();
        },
        join: async function() {
          self.instances.loading = true;
          if (self.info.retakeWorkshopsAttendanceRequired && self.info.isRegistered) {
            await UserWorkshops.withdraw({userid: self.user._id, value1: self.info.registrationId}, {}).$promise;
          }
          try {
            const userWorkshop = await UserWorkshops.register({userid: self.user._id, value1: self.info.contentId, value2: self.activeInstance._id}, {}).$promise;
            await self.instances.updateUserStatus(userWorkshop).$promise;
            self.activeInstance.availableSeats--;
            self.info.showJoin = false;
            self.instances.loading = false;
          } catch (error) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['workshopviewer.unable_to_join']});
            console.log('error: ', error);
            self.instances.loading = false;
          };
          $scope.$apply();
        },
        wait: function() {
          if (self.inPreview) {
            Application.messaging.addMessage({type: 'info', duration: 4, text: self.translations['workshopviewer.action_disabled']});
            return;
          }
          self.instances.loading = true;
          UserWorkshops.wait({userid: self.user._id, value1: self.info.contentId, value2: self.activeInstance._id}, {}).$promise
          .then(function(userWorkshop) {
            self.instances.updateUserStatus(userWorkshop);
            Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['workshopviewer.you_have_joined']});
            self.activeInstance.availableWait--;
            self.instances.loading = false;
          }).catch(function(error) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['workshopviewer.unable_to_join_waitlist']});
            self.instances.loading = false;
            console.log('error: ', error);
          });
        },
        leave: function() {

          if (self.inPreview) {
            Application.messaging.addMessage({type: 'info', duration: 4, text: self.translations['workshopviewer.action_disabled']});
            return;
          }
          self.instances.loading = true;
          UserWorkshops.withdraw({userid: self.user._id, value1: self.activeInstance.userActive._id}, {}).$promise
          .then(function(userWorkshop) {
            self.instances.updateUserStatus(userWorkshop);
            Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['workshopviewer.you_have_left']});
            if (!self.activeInstance.availableSeats) {
              self.activeInstance.availableWait++;
            } else {
              self.activeInstance.availableSeats++;
            }
            self.instances.loading = false;
          }).catch(function(error) {
            // handle error
            self.instances.loading = false;
            console.log('error: ', error);
          });
        },
        updateUserStatus: function(item) {
          var deferred = $q.defer();
          self.info.getUserParticipation()
          .then(function(items) {
            self.info.setUserParticipation(items);
            if (item) {
              self.activeInstance.userActive = item;
              self.instances.setButtons();
            }
            deferred.resolve();
          });

          return deferred.promise;
        },
        makeIcs: function(instance) {
          var addZero = function(value) {
            return (value < 10 ? '0' : '') + value;
          };

          var formatDate = function(date) {
            if (!date) {
              return '';
            }
            return date.getFullYear() + addZero(date.getMonth() + 1) + addZero(date.getDate());
          };

          var formatDateTime = function(dateTime) {
            return '' + dateTime.getUTCFullYear() + addZero(dateTime.getUTCMonth() + 1) + addZero(dateTime.getUTCDate()) + 'T' + addZero(dateTime.getUTCHours()) + addZero(dateTime.getUTCMinutes()) + addZero(dateTime.getUTCSeconds()) + 'Z';
          };

          var calculateDuration = function() {
            var start = new Date(instance.start_date);
            var end = new Date(instance.end_date);
            if (!start || !end) {
              return '';
            }
            var seconds = Math.abs(end.getTime() - start.getTime()) / 1000;
            var days = Math.floor(seconds / 86400);
            seconds -= days * 86400;
            var hours = Math.floor(seconds / 3600);
            seconds -= hours * 3600;
            var minutes = Math.floor(seconds / 60);
            seconds -= minutes * 60;
            return (start.getTime() > end.getTime() ? '-' : '') + 'P' + (days > 0 ? days + 'D' : '') + (hours || minutes || seconds ? 'T' + hours + 'H' : '') + (minutes || seconds ? minutes + 'M' : '') + (seconds ? seconds + 'S' : '');
          };

          var div = document.createElement("div");
          div.innerHTML = self.workshop.description;

          var location = self.translations['workshopviewer.undetermined'];

          if (instance.online) {
            location = instance.online_location || instance.online_location_label || self.translations['workshopviewer.online'];
          }
          if (!instance.online && instance.location) {
            location = instance.location.venue || instance.location.city_state || instance.location.country || self.translations['workshopviewer.undetermined'];
          }

          var workshopString = 'BEGIN:VCALENDAR\n' +
            'VERSION:2.0\n' +
            'PRODID:-//continu ' + self.workshop._id + '\n' +
            'METHOD:PUBLISH\n' +
            'BEGIN:VEVENT\n' +
            'UID:' + new Date().getTime() + '@' + self.workshop._id + '\n' +
            'DTSTAMP:' + formatDateTime(new Date()) + '\n' +
            'SUMMARY:' + (self.workshop.title || 'Workshop') + '\n' +
            'DTSTART:' + formatDateTime(new Date(instance.start_date)) + '\n' +
            'DTEND:' + formatDateTime(new Date(instance.end_date)) + '\n' +
            'URL:' + 'https://' + Application.navigation.getHost() + '/#/view/workshops/' + self.workshop._id + '\n' +
            'DESCRIPTION:' + (div.innerText || div.textContent || 'No Summary') + '\n' +
            'LOCATION:' + location + '\n' +
            'END:VEVENT\n' +
            'END:VCALENDAR';

            var url = 'http://www.google.com/calendar/event?action=TEMPLATE&text={t}&dates={s}/{e}&details={d}&location={l}&sprop=website:{u}'
            var inserts = {
              t: encodeURIComponent(self.workshop.title),
              d: encodeURIComponent(self.workshop.description),
              s: formatDateTime(new Date(instance.start_date)),
              e: formatDateTime(new Date(instance.end_date)),
              p: calculateDuration(instance.start_date, instance.end_date),
              l: encodeURIComponent(location),
              u: encodeURIComponent('https://' + Application.navigation.getHost() + '/#/view/workshops/' + self.workshop._id),
            };

            for (var item in inserts) {
              var re = new RegExp('\\{' + item + '\\}', 'g');
              url = url.replace(re, inserts[item]);
            }

            self.info.gCalLink = url;
            self.info.iCalDl = 'eventasics?content=' + $window.escape(workshopString);
        }
      };

      $scope.$watch('viewer.instances.changeDate', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.instances.setActive(newVal);
        self.instances.changeDate = null;
      });

      self.config = {
        relatedWorkshops: [],
        initialize: function() {
          self.config.loading = true;
          if ($scope.checkFull) {
            self.inPreview = true;
            if ($scope.fullData) {
              self.config.setFull();
              self.config.loading = false;
              return;
            }
            var fullWatch = $scope.$watch('fullData', function(newVal, oldVal) {
              if (newVal && !oldVal) {
                self.config.setFull();
                fullWatch();
                self.config.loading = false;
              }
            }, true);
            return;
          }

          if (!self.info.contentId && !$scope.fullData) {
            console.log('No id specified');
            Application.navigation.goToHome();
            return;
          }

          $q.all([
            Workshops.get({
              subresource: self.info.contentId,
              fields: 'title,description,image,banner_image,related_workshops,cover_justification,featured_justification,tags,private,privacy_departments,privacy_locations,privacy_teams,privacy_grades,privacy_org_levels,rating_configuration,average_rating,allow_comments,groups,surveys,allow_reregistration,require_attendance_for_reregistration',
              'related_workshops-populate': 'title,type,image,banner_image'
            }).$promise,
            WorkshopInstances.find({
              workshop: self.info.contentId,
              fields: 'workshop,start_date,end_date,viewing_timezone,seats,allow_waitlist,waitlist_seats,host,location,online,online_location,online_location_label,site,group,zoom_meeting_id',
              start_date: '$gt,date-' + moment().format('MM-DD-YY'),
              sort: 'start_date,1'
            }).$promise,
            self.info.getUserParticipation(),
            self.info.getUserLocations()
          ]).then(function(data) {
            self.workshop = data[0];
            $window.document.title = self.workshop.title;
            var options = data[1] || [];
            options = options.reduce(function(acc, instance) {
              if (instance.end_date && new Date(instance.end_date) > new Date()) {
                acc.push(instance);
              }
              return acc;
            }, []);

            var navTo = self.info.setUserParticipation(data[2], true);
            self.info.userLocations = data[3];
            navTo = navTo && navTo.workshop_instance || null;

            if (self.workshop.average_rating) {
              self.rating = Math.round(self.workshop.average_rating * 5) / 100;
            }

            if (options && options.length) {
              options.sort(function(a, b) {
                return new Date(a.start_date).valueOf() - new Date(b.start_date).valueOf();
              });
            }

            if (self.workshop.allow_reregistration) {
              if (self.workshop.require_attendance_for_reregistration) {
                self.info.retakeWorkshopsAttendanceRequired = true;
              } else {
                self.info.retakeWorkshopsUnlimited = true;
              }
            }

            var activeUw;
            if (data[2] && data[2].length) {
              data[2].forEach(function(item) {
                if (item.active_status) {
                  if (item.active_status === 'attended' || (item.active_status === 'registered' && !activeUw)) {
                    if (item.active_status === 'attended') {
                      self.ratingInstance = item.workshop_instance;
                      self.triggerRating = true;
                      self.attended = true;
                    }
                    activeUw = item;
                    return;
                  }
                }
              });
            }

            if (activeUw) {
              var foundInstance;
              for (var i = 0; i < options.length; i++) {
                if (options[i]._id === activeUw.workshop_instance) {
                  foundInstance = true;
                  break;
                }
              }
              if (!foundInstance) {
                self.attended = true;
              }
            }

            self.instances.options = options;
            ContentAuth.allowView(self.workshop)
            .then(function(allowed) {
              if(!allowed) {
                Application.messaging.addMessage({type: 'error', text: self.translations['workshopviewer.permission_error'], duration: 5});
                Application.navigation.back();
                return 'Not Allowed';
              }

              if (!self.attended) {
                return;
              }

              return WorkshopInstances.get({
                subresource: activeUw.workshop_instance,
                fields: 'workshop,start_date,end_date,viewing_timezone,seats,allow_waitlist,waitlist_seats,host,location,online,online_location,online_location_label,site,group,zoom_meeting_id,zoom_settings,recordings'
              }).$promise;
            }).then(async function(results) {
              if (results === 'Not Allowed') {
                return;
              }

              if (results) {
                if (results.recordings && results.recordings.length) {
                  self.recordingOpts.show = true;
                  self.recordingOpts.parseRecordings(results.recordings);
                  if (!self.inEditing && self.attended && self.recordingOpts.recordings[0] && self.recordingOpts.recordings[0].link && !self.triggerRating) {
                    self.recordingsModal = true;
                  }
                }

                // Removes attended "active" instance before the full result is added, creating duplicates
                const existingInstance = self.instances.options.find(instance => instance._id === results._id);
                if (existingInstance) {
                  const existingInstanceIndex = self.instances.options.indexOf(existingInstance);
                  self.instances.options.splice(existingInstanceIndex, 1);
                }

                self.instances.options.push(results);
                navTo = results._id;
              }

              if (self.attended && !results) {
                self.attended = false;
              }

              if (self.attended && self.workshop.surveys?.length && self.flags.surveys) {
                self.hideSurvey = await SurveyHelper.hideSurvey(self.inJourney, self.workshop.surveys[0].survey_id, self.workshop._id)
                $scope.$apply();
              }

              Analyze.record({resource: 'views'}, {content: self.workshop._id, content_type: 'workshop'});
              Application.analyticsProvider.trackEvent('workshop_viewed', {content: self.workshop._id, content_type: 'workshop', title: self.workshop.title});
              // ** Set up tracking here
              self.tracking.start(self.workshop);
              self.instances.setInstanceNames();
              self.instances.setActive(navTo, true);
              self.config.setRelated();
              self.config.loading = false;
            });

          }).catch(function (error) {
            console.log('Error occured getting workshop ', self.info.contentId, error);
            self.config.loading = false;
          });

        },
        setFull: function() {
          self.info.contentId = $scope.fullData._id;
          self.workshop = $scope.fullData;
          var options = $scope.instances || [];
          if (options && options.length) {
            options.sort(function(a, b) {
              return new Date(a.start_date).valueOf() - new Date(b.start_date).valueOf();
            });
          }
          self.instances.options = options;
          self.instances.setActive(options[0] || {}, true);
          self.config.setRelated();
        },
        setRelated: function() {
          var promises = [];
          if (!self.workshop.related_workshops || !self.workshop.related_workshops.length) {
            return;
          }
          var workshopIds = self.workshop.related_workshops.map(function(item) {
            if (typeof item === 'string') {
              return item;
            }
            if (item._id) {
              return item._id;
            }
          });
          if (!workshopIds || !workshopIds.length) {
            return;
          }

          var promises = [
            WorkshopInstances.find({
              workshop: '$in,' + workshopIds.length + ',' + workshopIds.join(','),
              fields: 'workshop,start_date,location,online'
            }).$promise
          ];

          if (typeof self.workshop.related_workshops[0] === 'string') {
            promises.push(
              Workshops.find({
                _id: '$in,' + workshopIds.length + ',' + workshopIds.join(','),
                fields: '_id,type,title,image,banner_image'
              }).$promise
            );
          }

          $q.all(promises).then(function(data) {
            var instances = data[0];
            var workshops = data[1] || self.workshop.related_workshops || [];
            var options = {};
            workshops.forEach(function(workshop) {
              options[workshop._id] = {workshop: workshop, instance: null};
            });
            instances.forEach(function(instance) {
              if (options[instance.workshop].instance) {
                options[instance.workshop].instance = 'multiple';
                return;
              }
              options[instance.workshop].instance = instance;
            });
            for (var key in options) {
              self.config.relatedWorkshops.push(options[key]);
            }
          });

        },
        image: function(workshop) {
          if (workshop.image || workshop.banner_image) {
            var imageUrl = workshop.image || workshop.banner_image || '';
            return Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + '/' + imageUrl;
          }
          return '';
        },
        makeDate: function(instance) {
          if (!instance || !instance.start_date) {
            return '';
          }
          return moment(new Date(instance.start_date).valueOf()).tz(guessedTz).format('ddd, MMM h:mmA');
        },
        goTo: function(workshop) {
          if (!workshop || !workshop._id) {
            return;
          }
          if (workshop.type === 'multi_session_workshop') {
            Application.navigation.goTo('view/multi-session-workshops/' + workshop._id);
          } else {
            Application.navigation.goTo('view/workshops/' + workshop._id);
          }
        }
      };

      $scope.$on('$destroy', function() {
        $location.search({});
        if (!self.inEditing) {
          self.tracking.end();
        }
      });

      $translate([
        "workshopviewer.action_disabled",
        "workshopviewer.unable_to_join",
        "workshopviewer.you_have_joined",
        "workshopviewer.unable_to_join_waitlist",
        "workshopviewer.you_have_left",
        "workshopviewer.undetermined",
        "workshopviewer.online",
        "workshopviewer.undetermined",
        "workshopviewer.permission_error"
      ]).then(function (translations) {
        self.translations = translations;
        self.config.initialize();
      });

    }],
    controllerAs: 'viewer'
  };
}]);
